import SEO from '../components/SEO/SEO'
import Portfolio from '../components/Portfolio/Portfolio'

export default function PortfolioPage() {
  return (
    <>
      <SEO
        title="Tattoo Portfolio Adelaide | Jesse B Tattoos"
        description="Browse Jesse B Tattoos portfolio in Adelaide. Bold traditional, neo-traditional, illustrative, black and grey, and Tattoo Therapy pieces."
        canonical="https://jessebtattoos.com/portfolio"
        keywords="tattoo portfolio Adelaide, Jesse B Tattoos work, traditional tattoos, neo traditional tattoos, black and grey tattoos Adelaide"
        ogType="website"
      />
      <Portfolio />
    </>
  )
}